module.exports = __webpack_public_path__ + "static/media/yoga-abracoliberta.cd0acd53.jpg";